import {chain} from 'lodash';

import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {ActivityVisualTypesEnum} from '../../../models/api/activityModel';
import {MessageModel} from '../../../models/api/messageModel';
import {ThunkAction} from '../../appThunk';
import {ViewerPanelId} from '../../panels/panelStateBase';
import {makeGetViewerPanel} from '../../panels/viewer/viewerPanelSelectors';
import {ViewerPanelPageTypesEnum} from '../../panels/viewer/viewerPanelState';
import {getActivities, getMessages} from '../dataSelectors';

export function listLoadedMessageAction(
  panelId: ViewerPanelId,
  conversationId: number,
): ThunkAction<ReadonlyArray<MessageModel>> {
  return (_dispatch, getState) => {
    const panel = makeGetViewerPanel()(getState(), {panelId});
    const viewerPage = panel?.pages.current;

    // Make sure the viewer page is loaded for the correct conversation.
    if (
      viewerPage?.type !== ViewerPanelPageTypesEnum.SINGLE_CONVERSATION ||
      viewerPage.conversationId !== conversationId ||
      viewerPage.status !== AsyncStatusesEnum.LOADED
    ) {
      return [];
    }

    const messages = getMessages(getState());
    const activities = getActivities(getState());

    return chain(viewerPage.activities)
      .keys()
      .map((id) => activities[id])
      .compact()
      .sortBy((a) => a.date)
      .map((a) => a.visualType === ActivityVisualTypesEnum.MESSAGE && messages[a.messageUid])
      .compact()
      .value();
  };
}
